import { create } from 'zustand';

interface PageLoaderState {
  rotation: number;
  setRotation: (rotation: number) => void;
  incrementRotation: (increment: number) => void;
}

export const usePageLoaderStore = create<PageLoaderState>((set) => ({
  rotation: 0,
  setRotation: (rotation: number) => set({ rotation }),
  incrementRotation: (increment: number) =>
    set((state) => ({ rotation: (state.rotation + increment) % 360 })),
}));
